import React from "react";
import {  Statistic, Card, Row, Col } from 'antd'
import { UserIcon, ClientsIcon, VideoIcon, RadiationIcon, DecreaseIcon, IncreaseIcon, } from "../Icon";
const DashboardStatisticsHeader = () => {
  const arr = [
    {
    userRole: 'Clients',
    sum: '24.4K',
    percentageChange: '11.4%',
    increase: false
    },
    {
      userRole: 'Users',
      sum: '24.4K',
      percentageChange: '11.4%',
      increase: false
      },
    {
      userRole: 'Artists',
      sum: '24.4K',
      percentageChange: '11.4%',
      increase: false
      },
    {
      userRole: 'Live Users',
      sum: '24.4K',
      percentageChange: '11.4%',
      increase: true
    }
  ]

  return (
    <Row gutter={24} className="dashboard-statistic-header">
      {arr.map(element => (
        <Col span={6}>
          <Card className="single-statistic-element">
            <div className="statistic-role">
              {element.userRole === 'Clients' ? <ClientsIcon /> : element.userRole === 'Users' ?  
              <UserIcon /> : element.userRole === 'Artists' ? <VideoIcon /> :  <RadiationIcon />}
                <p className="statistic-role-text">{element.userRole}</p>
              </div> 
              <p className="statistic-sum">{element.sum}</p> 
              <div className="variation-nums">
                {element.increase ? <IncreaseIcon /> :  <DecreaseIcon />}
                <p className="decrease-text">{element.percentageChange}</p>
            </div>  
          </Card> 
          </Col>
      ))}
    </Row>
  )
}

export default DashboardStatisticsHeader;
